<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="flex flex-col gap-4">
    <!-- STATS -->
    <div v-if="statisticsStore.getStatistic" class="grid grid-flow-col gap-4">
      <div class="stats stats-vertical lg:stats-horizontal shadow text-white bg-secondary">
        <div class="stat border border-r-white">
          <div class="stat-title text-white">Anwendungen</div>
          <div class="stat-value">{{ statisticsStore.getStatistic.system.clients }}</div>
          <div class="stat-desc text-white">Registrierte Anwedungen</div>
        </div>

        <div class="stat">
          <div class="stat-title text-white">Benutzer</div>
          <div class="stat-value">{{ statisticsStore.getStatistic.system.users }}</div>
          <div class="stat-desc text-white">Registrierte Benutzer</div>
        </div>

        <div class="stat border border-l-white">
          <div class="stat-title text-white">Sessions</div>
          <div class="stat-value">{{ statisticsStore.getStatistic.system.sessions }}</div>
          <div class="stat-desc text-white">Aktiv angemeldete Benutzer</div>
        </div>

        <div class="stat border border-l-white border-r-white">
          <div class="stat-title text-white">Tokens</div>
          <div class="stat-value">{{ statisticsStore.getStatistic.system.tokens }}</div>
          <div class="stat-desc text-white">Aktive Zugangsschlüssel</div>
        </div>

        <div class="stat border-l-white border-r-white">
          <div class="stat-title text-white">Aktivierungsschlüssel</div>
          <div class="stat-value">{{ statisticsStore.getStatistic.system.activation_codes }}</div>
          <div class="stat-desc text-white">Aktive Aktivierungsschlüssel</div>
        </div>
      </div>
    </div>

    <!-- CHART -->
    <widget-component>
      <template #content>
        <div class="text-xl font-bold text-secondary">Heutige Anmeldungen</div>
        <div id="login_history_chart"></div>
      </template>
    </widget-component>

    <user-agent-report-component v-if="statisticsStore.getStatistic"></user-agent-report-component>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useStatisticsStore } from "@/stores/statistics";
import ApexCharts from "apexcharts";
import UserAgentReportComponent from "@/components/UserAgentReportComponent";
import WidgetComponent from "@/components/WidgetComponent";
import _ from "lodash";

export default {
  name: "DashboardView",
  components: { WidgetComponent, UserAgentReportComponent },
  data() {
    return {
      stats: undefined,
      loginHistoryChart: undefined
    };
  },
  computed: {
    ...mapStores(useStatisticsStore)
  },
  async created() {
    const currentDate = new Date();
    await this.statisticsStore.fetchStatistic(new Date(currentDate.setUTCHours(0, 0, 0)), new Date(currentDate.setUTCHours(23, 59, 59)));
    this.renderLoginHistoryChart();
  },
  unmounted() {
    this.loginHistoryChart.destroy();
  },
  methods: {
    renderLoginHistoryChart() {
      const options = {
        chart: {
          type: "line",
          height: "600px"
        },
        colors: ["#183857"],
        series: [{
          name: "Anmeldungen",
          data: this.mergeLoginHistory().map((analytics) => {
            return {
              x: `${analytics._id.hour} Uhr`,
              y: analytics.count
            };
          })
        }],
        xaxis: {
          type: "numeric"
        }
      };

      this.loginHistoryChart = new ApexCharts(document.querySelector("#login_history_chart"), options);
      this.loginHistoryChart.render();
    },
    mergeLoginHistory() {
      const timeSpan = [];

      for (let i = 0; i <= 24; i++) {
        timeSpan.push({
          _id: {
            hour: i
          },
          count: 0
        });
      }

      return _.orderBy(_.unionBy(this.statisticsStore.getStatistic.login, timeSpan, "_id.hour"), ["_id.hour"]);
    }
  }
};
</script>
